import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: New Orleans — ~35 mi across Lake Pontchartrain",
      "NPIC appointment required before traveling to New Orleans",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive across the Causeway needed",
      "Ideal for St. Tammany professionals commuting to New Orleans",
      "Perfect for Mandeville families with European vacations booked",
      "Great for lakefront retirees with Mediterranean cruises",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Mandeville or Covington post offices",
      "Good for planned international trips from MSY",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Mandeville or Covington USPS",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
];

export default function MandevilleProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Mandeville"
      introText="Mandeville residents — St. Tammany Parish professionals commuting across the Causeway to New Orleans, families planning summer trips to Europe from MSY, and lakefront retirees with Mediterranean cruises on the calendar — have several options for getting a passport fast. Here is how they compare, and why most Northshore residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the drive into New Orleans."
      options={options}
      emergencyDescription="Mandeville does not have its own regional passport agency. The closest is New Orleans — about 35 miles south across the Lake Pontchartrain Causeway, typically 45–60 minutes but often longer with Causeway and downtown New Orleans traffic. For a St. Tammany professional with a last-minute business trip or a family with a cruise departing from the Port of New Orleans, that round trip across the bridge is a full-day commitment."
      disclaimerText="*Processing speed depends on eligibility and documentation. Mandeville does not have a regional passport agency — the closest is New Orleans. Not all applicants qualify for Regional Agency Processing."
    />
  );
}